import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { buildDocumentTitle } from '@core/branding/public-brand';

/**
 * Auth/login no debe competir en SERP con milinco.com.
 * Title neutro + robots noindex,nofollow (robots.txt ya Disallow /authentication/).
 */
@Injectable({ providedIn: 'root' })
export class AuthSeoService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly doc = inject(DOCUMENT);
  private active = false;

  apply(): void {
    this.active = true;
    this.title.setTitle(buildDocumentTitle(null));
    this.doc.documentElement.lang = 'es';
    this.upsertMetaName('robots', 'noindex,nofollow');
    this.upsertMetaName(
      'description',
      'Acceso a Milinco. Inicia sesión o crea tu cuenta para gestionar tu negocio.'
    );
  }

  clear(): void {
    if (!this.active) {
      return;
    }
    this.active = false;
    this.removeMetaName('robots');
    this.removeMetaName('description');
  }

  private upsertMetaName(name: string, content: string): void {
    if (this.meta.getTag(`name="${name}"`)) {
      this.meta.updateTag({ name, content });
      return;
    }
    this.meta.addTag({ name, content });
  }

  private removeMetaName(name: string): void {
    this.meta.removeTag(`name="${name}"`);
  }
}
